import { render, staticRenderFns } from "./admin_data.vue?vue&type=template&id=ae81096a"
import script from "./admin_data.vue?vue&type=script&lang=js"
export * from "./admin_data.vue?vue&type=script&lang=js"
import style0 from "./admin_data.vue?vue&type=style&index=0&id=ae81096a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports